import { Action } from '@ngrx/store';
import { GetOverviewResponse } from '../models/overview';
import { IOverviewConfigurationModel } from '../models/overview-configuration-model';
import { EntityKey } from '@feature/pma-entity/pma-entity-types';
import { UserPreferencesData } from '@feature/user-preferences/models/user-preferences-data';

export const LOAD = '[Overview] Load Overview Content';
export const LOAD_COMPLETE = '[Overview] Load Complete';
export const LOAD_ERROR = '[Overview] Load Error';

export const LOAD_CONFIGURATION = '[Overview] Load Overview Configuration';
export const LOAD_CONFIGURATION_COMPLETE = '[Overview] Load Overview Configuration Complete';
export const LOAD_CONFIGURATION_ERROR = '[Overview] Load Overview Configuration Error';



export class Load implements Action {
  readonly type = LOAD;
  constructor(public key: EntityKey) { }
}

export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: GetOverviewResponse) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload: any) { }
}

export class LoadConfiguration implements Action {
  readonly type = LOAD_CONFIGURATION;
  constructor() { }
}

export class LoadConfigurationComplete implements Action {
  readonly type = LOAD_CONFIGURATION_COMPLETE;
  constructor(public payload: IOverviewConfigurationModel) { }
}

export class LoadConfigurationError implements Action {
  readonly type = LOAD_CONFIGURATION_ERROR;
  constructor(public payload: any) { }
}



export type Actions =
  Load |
  LoadComplete |
  LoadError |
  LoadConfiguration |
  LoadConfigurationComplete |
  LoadConfigurationError
